import { lazy } from 'react';

import { createBrowserRouter, Outlet } from 'react-router-dom';

import { LandingParamsInterceptor } from '@/features/landingFlow';
import { RecordingEntryCapture } from '@/features/recordingEntry';

import { PATHS } from '@/shared/constants/routes/paths';

import { InitAppLayout } from '../layouts';
import { PaymentDelayLayout } from '../layouts/PaymentDelayLayout';
import { AuthLostWatcher } from './AuthLostWatcher';
import { AuthRoutes } from './authRoutes';
import { localizationAuthRoutes } from './authRoutes/localizationAuthRoutes';
import { ProtectedRoute } from './ProtectedRoute';

const ErrorPage = lazy(() => import('@/pages/ErrorPage'));
const AuthRoute = lazy(() => import('./AuthRoute'));
const PublicRecordingRedirect = lazy(() => import('@/pages/PublicRecordingRedirect'));
const RecordingSharePage = lazy(() => import('@/pages/RecordingSharePage'));
const TrialSharePage = lazy(() => import('@/pages/TrialSharePage'));

const RootLayout = () => (
  <>
    <AuthLostWatcher />
    <Outlet />
  </>
);

export const router = createBrowserRouter([
  {
    children: [
      {
        children: [
          {
            element: <RecordingEntryCapture />,
            path: PATHS.recordingEntry,
          },
          {
            element: <RecordingSharePage />,
            path: PATHS.recordingShare,
          },
          {
            element: <TrialSharePage />,
            path: PATHS.trialShare,
          },
          {
            element: <AuthRoute />,
            path: PATHS.auth,
          },
          {
            element: <PublicRecordingRedirect />,
            path: `${PATHS.records}/:recordId`,
          },
          {
            children: [
              {
                children: [
                  {
                    children: [
                      {
                        children: localizationAuthRoutes,
                        element: <AuthRoutes />,
                      },
                    ],
                    element: <InitAppLayout />,
                  },
                ],
                element: <PaymentDelayLayout />,
              },
            ],
            element: <ProtectedRoute />,
            errorElement: <ErrorPage />,
          },
        ],
        element: <LandingParamsInterceptor />,
      },
    ],
    element: <RootLayout />,
  },
]);
